import React from 'react';
import { Typography } from '@material-ui/core';
import { RBButton } from '../../components/RBButton';
import { Colors, Font, FontWeight, Spacing } from '../../theme/Theme';

export interface ShiftCompletedRatingPromptProps {
  onRateNow: () => void;
  onRateLater: () => void;
  primaryColor: string;
  roleLabel?: string;
  confirmationMessage?: string;
  feedbackMessage?: string;
}

const ShiftCompletedRatingPrompt: React.FC<ShiftCompletedRatingPromptProps> = ({
  onRateNow,
  onRateLater,
  primaryColor,
  roleLabel,
  confirmationMessage,
  feedbackMessage,
}) => {
  const resolvedRoleLabel = roleLabel?.trim() ? roleLabel.trim() : 'relief';
  const resolvedConfirmationMessage =
    confirmationMessage ??
    'The shift hours are confirmed, and a statement has been sent to you by email.';
  const resolvedFeedbackMessage =
    feedbackMessage ??
    `Your feedback is important to us! Please take a minute to rate the performance of the ${resolvedRoleLabel} you had working this shift.`;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: Spacing.small,
        paddingBottom: Spacing.medium,
      }}
    >
      <Typography
        style={{
          fontSize: Font.default,
          color: Colors.darkGrey,
          textAlign: 'center',
          marginBottom: Spacing.medium,
        }}
      >
        {resolvedConfirmationMessage}
      </Typography>

      <Typography
        style={{
          fontSize: Font.default,
          color: Colors.darkGrey,
          textAlign: 'center',
          marginBottom: Spacing.large,
        }}
      >
        {resolvedFeedbackMessage}
      </Typography>

      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <RBButton
          style={{ flex: 1, marginRight: Spacing.small }}
          buttonBackgroundColor={primaryColor}
          text="Rate Now"
          onClick={onRateNow}
        />
        <RBButton
          style={{ flex: 1, marginLeft: Spacing.small }}
          buttonBackgroundColor={primaryColor}
          text="Rate Later"
          onClick={onRateLater}
        />
      </div>
    </div>
  );
};

export default ShiftCompletedRatingPrompt;